import SubjectService from "../SubjectService"
import SubjectContactBasicEntity from "../Entity/SubjectContactBasicEntity"

const
    CREATING_RECORD = "CREATING_RECORD",
    CREATING_RECORD_SUCCESS = "CREATING_RECORD_SUCCESS",
    CREATING_RECORD_ERROR = "CREATING_RECORD_ERROR",
    FETCHING_RECORDS = "FETCHING_RECORDS",
    FETCHING_RECORDS_SUCCESS = "FETCHING_RECORDS_SUCCESS",
    FETCHING_RECORDS_ERROR = "FETCHING_RECORDS_ERROR",
    UPDATING_RECORD = "CREATING_RECORD",
    UPDATING_RECORD_SUCCESS = "CREATING_RECORD_SUCCESS",
    UPDATING_RECORD_ERROR = "CREATING_RECORD_ERROR",
    DELETING_RECORD = "DELETING_RECORD",
    DELETING_RECORD_SUCCESS = "DELETING_RECORD_SUCCESS",
    DELETING_RECORD_ERROR = "DELETING_RECORD_ERROR",
    CLEAR_RECORDS = "CLEAR_RECORDS",
    CLEAR_RECORD = "CLEAR_RECORD"

const initialState = {
    isLoading: false,
    isProcessing: false,
    record: null,
    records: [],
    totalRecords: 0,
    error: null,
}

export const state = {...initialState}

export const actions = {

    /**
     * @param commit
     * @param id : string
     * @returns {Promise<any>}
     */
    async getContacts({commit}, id) {
        try {
            commit(FETCHING_RECORDS)
            let response = await SubjectService.getSubjectContacts(id)
            commit(FETCHING_RECORDS_SUCCESS, response.data)
            return state.records
        } catch (error) {
            commit(FETCHING_RECORDS_ERROR, error)
            return Promise.reject(error)
        }
    },

    /**
     * @param commit
     * @param id : String
     * @param request : SubjectContactRequest
     * @returns {Promise<*>}
     */
    async createSubjectContact({commit}, {id, request}) {
        try {
            commit(CREATING_RECORD)
            let response = await SubjectService.createSubjectContact(id, request)
            commit(CREATING_RECORD_SUCCESS, response.data)
            return state.record
        } catch (error) {
            commit(CREATING_RECORD_ERROR, error)
            return Promise.reject(error)
        }
    },

    /**
     * @param commit
     * @param subject : string
     * @param id : string
     * @param request : SubjectContactRequest
     * @returns {Promise<*>}
     */
    async updateSubjectContact({commit}, {subject, id, request}) {
        try {
            commit(UPDATING_RECORD)
            let response = await SubjectService.updateSubjectContact(subject, id, request)
            commit(UPDATING_RECORD_SUCCESS, response.data)
            return state.record
        } catch (error) {
            commit(UPDATING_RECORD_ERROR, error)
            return Promise.reject(error)
        }
    },

    /**
     * @param commit
     * @param subject : string
     * @param id : string
     * @returns {Promise<*>}
     */
    async deleteSubjectContact({commit}, {subject, id}) {
        try {
            commit(DELETING_RECORD)
            let response = await SubjectService.deleteSubjectContact(subject, id)
            commit(DELETING_RECORD_SUCCESS, response.data)
            return state.record
        } catch (error) {
            commit(DELETING_RECORD_ERROR, error)
            return Promise.reject(error)
        }
    },

    clear({commit}) {
        commit(CLEAR_RECORD)
    },

    clearAll({commit}) {
        commit(CLEAR_RECORDS)
    },

}

export const mutations = {

    [FETCHING_RECORDS](state) {
        state.isLoading = true
        state.error = null
        state.records = []
    },
    [FETCHING_RECORDS_SUCCESS](state, data) {
        state.isLoading = false
        state.error = null
        state.records = data.map(record => SubjectContactBasicEntity.from(record))
        state.totalRecords = data.length
    },
    [FETCHING_RECORDS_ERROR](state, error) {
        state.isLoading = false
        state.error = error
        state.records = []
    },

    [CREATING_RECORD](state) {
        state.isProcessing = true
        state.error = null
    },
    [CREATING_RECORD_SUCCESS](state, data) {
        state.isProcessing = false
        state.error = null
        state.record = SubjectContactBasicEntity.from(data)
    },
    [CREATING_RECORD_ERROR](state, error) {
        state.isProcessing = false
        state.error = error
    },

    [UPDATING_RECORD](state) {
        state.isProcessing = true
        state.error = null
    },
    [UPDATING_RECORD_SUCCESS](state, data) {
        state.isProcessing = false
        state.error = null
        state.record = SubjectContactBasicEntity.from(data)
    },
    [UPDATING_RECORD_ERROR](state, error) {
        state.isProcessing = false
        state.error = error
    },

    [DELETING_RECORD](state) {
        state.isProcessing = true
        state.error = null
    },
    [DELETING_RECORD_SUCCESS](state) {
        state.isProcessing = false
        state.error = null
    },
    [DELETING_RECORD_ERROR](state, error) {
        state.isProcessing = false
        state.error = error
    },

    [CLEAR_RECORD](state) {
        state.isLoading = false
        state.error = null
        state.record = null
    },

    [CLEAR_RECORDS](state) {
        state.isLoading = false
        state.error = null
        state.records = []
        state.totalRecords = 0
    },

}

export const getters = {

    isLoading(state) {
        return state.isLoading
    },

    isProcessing(state) {
        return state.isProcessing
    },

    hasError(state) {
        return state.error !== null
    },

    error(state) {
        return state.error
    },

    hasContact(state) {
        return state.record !== null
    },

    getContact(state) {
        return state.record
    },

    hasContacts(state) {
        return state.records.length > 0
    },

    getContacts(state) {
        return state.records
    },

    getTotalContacts(state) {
        return state.totalRecords
    },
}

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
}
